<template>
	<div class='main-mybody1' id='looktwo'>
		<a-row>
			<a-col :span='12'>
				<a-row v-for='(item,ind) in tablelist.leftresult' :key='ind+"1001"'>
					<div class='look_g'>
						<div></div>{{item.firstclassname}}
					</div>
					<a-row  v-for='(items,inds) in item.secondList' :key='inds+"1002"'>
						<a-col :span='24'><span class='warp_titlesfasc'>{{items.secondclassname}}</span></a-col>
						<a-col :span='4' v-if='items.details.length == 0'>
							<span class='grayman'>暫無權限</span>
						</a-col>
						<a-col :span='5' v-else
						 v-for='(val,i) in items.details' :key='i+"1003"'>
							<div class='warp_gre'><img :src="require('@/image/dian.png')" alt=""></div> <span class='grayman'>{{val}}</span></a-col>
					</a-row>
					<div class='main-wid main-wids' v-if='ind+1<tablelist.leftresult.length'></div>
				</a-row>
			</a-col>
			
			<a-col :span='12'>
				<a-row v-for='(item,ind) in tablelist.rightresult' :key='ind+"2020"'>
					<div class='look_g'>
						<div></div>{{item.firstclassname}}
					</div>
					<a-row  v-for='(items,inds) in item.secondList' :key='inds+"2021"'>
					<a-col :span='24'><span class='warp_titlesfasc'>{{items.secondclassname}}</span></a-col>
					<a-col :span='4' v-if='items.details.length == 0'>
						<span class='grayman'>暫無權限</span>
					</a-col>
					<a-col :span='4' v-else
					 v-for='(val,i) in items.details' :key='i+"2022"'>
						<div class='warp_gre'><img :src="require('@/image/dian.png')" alt=""></div> <span class='grayman'>{{val}}</span></a-col>
					</a-row>
					<div class='main-wid main-wids' v-if='ind+1<tablelist.rightresult.length'></div>
				</a-row>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				tablelist:{
					leftresult:[],
					rightresult:[{
						firstclassname: "",
						firstid: '',
						roledetailstr: "",
						secondList:[{
							details: [],
							firstid: '',
							id: '',
							roledetailstr: "",
							secondclassname: "",
						}]
					}]
				}
			}
		},
		mounted() {
			this.getdate()
		},
		methods:{
			getdate(){
				this.$ajax({
					url:this.$api.getAllRoleDetails,
					method:'POST',
					data:{
						token:this.$store.state.token
					}
				}).then(res=>{
					console.log(res.data)
					if(res.data.qmiscode === 1000){
						this.tablelist = res.data
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	#looktwo{
		.warp_gre{
			width: .5rem;
			height: .5rem;
			// background-color: #0c8b97;
			// border-radius: 25rem;
			line-height: .5rem;
			display: inline-block;
			position: relative;
			margin-right: .2rem;
			// top: .03rem;
		}
		.main-wids{
			width: 80%;
		}
		.warp_titlesfasc{
			font-size: .75rem;
		}
		.grayman{
			color: gray;
			font-size: .65rem;
		}
	}
</style>
